<template>
	<div class="mobileLgWrap_he">
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="短信验证登录" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>

		<div class="loginMain_he">
			<form>
				<van-cell-group>
					<van-field v-model="mobile" name="mobile" clearable label-align="left" placeholder="请输入手机号"  />
					<div class="bd_he">
						<van-field @input="changColor" v-model="yzm" placeholder="请输入短信验证码" type="text" name="yzm" clearable label-align="left">
							<van-button slot="button" size="small" plain type="info" @click="sendMessage" :disabled="sendCodeBtnDisabled">{{
								sendCodeCaption
							}}</van-button>
						</van-field>
					</div>
					<p class="register_forget_he">
						<a href="javascript:;" class="fl" @click="goRegister">新用户注册</a>
						<a href="javascript:;" class="fr" @click="goForgetPassword">忘记密码?</a>
					</p>
					<div :class="passwordNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'" @click="login()">
						<span><a href="javascript:;">登录</a></span>
					</div>
					<div @click="passwordLogin" class="mobileLoginBtn-message">密码登录</div>
				</van-cell-group>
			</form>
		</div>
	</div>
</template>

<script>
import md5 from "js-md5";
const Base64 = require("js-base64").Base64;
import { Toast } from "vant";
export default {
	data() {
		return {
			yzm: "",
			password: "",
			mobile: "",
            passwordNum:"",
			phoneNum: "",
			// 计时器,注意需要进行销毁
			sendCodeBtnDisabled: false,
			sendCodeCaption: "获取验证码",
			type: "login",
		};
	},
	methods: {
		//密码登录
		passwordLogin() {
			this.$router.push({ path: "/mobileLogin" });
		},
		// 切换按钮颜色
		changColor(e) {
			this.passwordNum = e.length;
		},
		/**
		 * 登录函数
		 */
		login() {
			// 先判断手机号是否为空 为空输入手机号
			if (this.mobile == "") {
				Toast("请先输入手机号");
			} else {
				if (!this.$util.isPhoneNumber(this.mobile)) {
					Toast("请输入正确的手机号");
					return false;
				}
				if (this.yzm == "") {
					Toast("请先输入验证码");
					return false;
				}
			}
            this.loginNext();
		},
		loginNext() {
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/user/h5loginByPhone",
				{ phoneNum: this.mobile, code: this.yzm },
				null,
				null,
				(resD) => {
					if (resD) {
						localStorage.setItem("loginUrl", resD);
						Toast("登录成功");
						this.$axiosPackag.getMessageByAxios("GET", "/session/getSession", null, null, null, (resD) => {
							if (resD) {
								this.$sessionStore.initSession(resD);
								this.$router.push({ path: "/mobileHome" });
							}
						});

						// mobilePersonal
					}
				},
				(errorCall) => {}
			);
		},
		/**
		 * 跳转到注册页面
		 */
		goRegister() {
			Toast("去注册");
			this.$router.push({
				path: "/mobileRegister",
			});
		},
		/**
		 * 跳转到忘记密码页面
		 */
		goForgetPassword() {
			this.$router.push({
				path: "/mobileForgetPassword",
			});
		},
		/**
		 *  判断手机号是否已经存在
		 **/
		//  GET /user/isExistMobile
		isExistMobile() {
			let param = {};
			param.type = this.type;
			param.mobile = this.mobile;
			this.$api.get("/user/isExistMobile", param, (res) => {
				if (res.status == 1) {
					Toast(res.message);
					return false;
				} else {
					let param = {};
					param.type = this.type;
					param.mobile = this.mobile;
					this.$api.get("/user/sendyanzheng", param, (res) => {
						if (res.status == 0) {
							Toast("已发送到您的手机");
							this.countDown();
						} else {
							Toast(res.message);
						}
					});
				}
			});
		},
		// 发送验证码
		sendMessage() {
			// 先判断手机号是否为空 为空输入手机号
			if (this.mobile == "") {
				Toast("请输入手机号");
				return false;
			} else if (!this.$util.isPhoneNumber(this.mobile)) {
				Toast("请输入正确的手机号");
				return false;
			}
			this.isExistMobile();
		},
		countDown() {
			var i = 60;
			this.sendCodeBtnDisabled = true;
			this.refreshTimer = setInterval(() => {
				this.sendCodeCaption = i + "秒后可重新发送";
				i = i - 1;
				if (i == 0) {
					this.clearCountDown();
				}
			}, 1000);
		},
		clearCountDown() {
			this.sendCodeBtnDisabled = false;
			this.sendCodeCaption = "获取验证码";
			clearInterval(this.refreshTimer);
		},
		onClickLeft() {
			this.$router.go(-1);
		},
	},
	created() {
		(this.mobile = ""), (this.password = "");
	},
};
</script>
<style >
.userNavBar .van-nav-bar__title {
	font-weight: 600;
}
</style>
<style scoped>
.userNavBar {
	width: 100%;
	
	margin-top: 0.133333rem;
}
.mobileLgWrap_he {
	background: none;
}
.van-cell,
.van-cell-group {
	background: none;
}
.van-cell {
	background: none;
	font-size: 16px;
}
.van-icon-eye-o::before {
	color: #6d7174;
}
.van-cell::after {
	border: none;
}
.van-cell {
	border-bottom: 0.026667rem solid #dfdede;
	margin-bottom: .72rem;
    font-size: 0.373333rem;
}
[class*="van-hairline"]::after {
	border: none;
}
.van-field {
	padding: 0.213333rem 0 0.213333rem 0;
}
.van-button {
	border: none;
}
</style>


// WEBPACK FOOTER //
// MobileLoginYzm.vue?49d0b32e